import React from 'react';
import StateSocialWorkerJobsPage from './StateSocialWorkerJobsPage';

const MichiganSocialWorkerJobs = () => {
  return (
    <StateSocialWorkerJobsPage
      stateName="Michigan"
      stateAbbr="MI"
      metaTitle="Michigan Social Worker Jobs (LMSW, LCSW, MSW) | INeedASocialWorker"
      metaDescription="Find Michigan social worker jobs in hospitals, hospice, schools, behavioral health, and community agencies. Search Detroit, Grand Rapids, Ann Arbor jobs. Apply fast."
      cities={[
        "Detroit",
        "Grand Rapids",
        "Ann Arbor",
        "Lansing",
        "Flint",
        "Dearborn",
        "Warren",
        "Sterling Heights",
        "Kalamazoo",
        "Troy",
        "Farmington Hills",
        "Livonia",
        "Traverse City"
      ]}
      stateDescription="Looking for social work jobs in Michigan? The Great Lakes State offers opportunities in major hospital systems, school districts, behavioral health agencies, and community organizations across metro Detroit and beyond."
      faqItems={[
        {
          question: "What types of social work jobs are hiring in Michigan right now?",
          answer: "Michigan employers commonly hire for hospital/medical social work, behavioral health, school-based services, child welfare (DHHS), and community mental health. The Detroit metro and Grand Rapids areas have the most openings."
        },
        {
          question: "What license do I need to practice social work in Michigan?",
          answer: "Michigan requires the LMSW (Licensed Master's Social Worker) for MSW graduates and the LLMSW (Limited Licensed Master's Social Worker) while completing supervised hours. The LBSW is available for BSW graduates."
        },
        {
          question: "What is the average salary for social workers in Michigan?",
          answer: "Michigan social workers typically earn $45,000-$70,000+ depending on setting, experience, and location. Ann Arbor and metro Detroit areas often offer higher compensation."
        },
        {
          question: "How do I apply faster?",
          answer: "Create your profile, upload your resume, and use one-click apply when available through our SW Express Apply™ feature."
        }
      ]}
    />
  );
};

export default MichiganSocialWorkerJobs;
